import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import fileService from "../services/Common/FileServiceClient";
import { toast } from "react-toastify";
import { CSpinner } from "@coreui/react";

const FileViewerPage = () => {
  const { type, fileName } = useParams();
  const containerRef = useRef(null);

  // Guard to ensure fetchFile runs only once
  const hasFetched = useRef(false);

  useEffect(() => {
    const fetchFile = async () => {
      if (hasFetched.current) return; // Prevent multiple executions
      hasFetched.current = true; // Mark as executed

      // If you need to check permissions, use user?.permissions?.includes('...')
      const response = await fileService.get(type, fileName);
      if (response.succeeded) {
        fileService.openFile(
          response.object,
          fileName,
          true,
          containerRef.current
        );
      } else {
        toast.error("There was a problem downloading the file.");
      }
    };

    fetchFile();
  }, [type, fileName]);

  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CSpinner color="info" className="card-spinner" />
    </div>
  );
};

export default FileViewerPage;
